import { UserClassification } from '@Models/types';
import TabPanel from './TabPanel';
import NewUserSettings from '@New/NewUserSettings';

interface WrapperTabPanelProps {
  index: number;
  requiredKeys: Array<'jira' | 'testrail'>;
  children: React.ReactNode;
  userType: UserClassification;
  jiraOnly?: boolean;
}

const WrapperTabPanel = ({
  index,
  requiredKeys,
  children,
  userType,
  jiraOnly,
}: WrapperTabPanelProps) => {
  const missingKeys: Array<
    'jira_email' | 'jira_api_key' | 'testrail_username' | 'testrail_api_key'
  > = [];

  if (
    requiredKeys.includes('jira') &&
    (userType === 'no-api' || userType === 'only-testrail')
  ) {
    missingKeys.push('jira_email', 'jira_api_key');
  }

  if (
    requiredKeys.includes('testrail') &&
    (userType === 'no-api' || userType === 'only-jira')
  ) {
    missingKeys.push('testrail_username', 'testrail_api_key');
  }

  const showSettings = missingKeys.length > 0;

  console.log(missingKeys);

  return (
    <TabPanel index={index}>
      {showSettings ? (
        <NewUserSettings missing={missingKeys} jiraOnly={jiraOnly} />
      ) : (
        children
      )}
    </TabPanel>
  );
};

export default WrapperTabPanel;
